import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/policies/audits'
)({
  beforeLoad: () => {
    throw redirect({ to: '/ndis-standards/audits' })
  },
  component: () => null,
})
